/**
 * The drop effect the rail asks for when a drive item is dropped on it to pin.
 * A link where the drag allows one; otherwise one the drag DOES allow — since
 * #605 every drive drag allows only copy/move (`offerDragToApps`), and a drop
 * effect outside `effectAllowed` makes the browser refuse the drop outright.
 */
export function railFileDropEffect(effectAllowed: string): 'link' | 'copy' | 'move' {
  if (effectAllowed === 'all' || effectAllowed === 'uninitialized' || /link/i.test(effectAllowed)) return 'link'
  return effectAllowed === 'move' ? 'move' : 'copy'
}
